/**
 * Modern Secondary Button Component
 * Replaces outline-gray-button with modern design system
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from './ui/Button';

const SecondaryButton = ({
  button,
  action,
  loading = false,
  disabled = false,
  leftIcon,
  rightIcon,
  size = 'md',
  variant = 'outline',
  ...props
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={action}
      loading={loading}
      disabled={disabled}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      {...props}
    >
      {button}
    </Button>
  );
};

SecondaryButton.propTypes = {
  button: PropTypes.string.isRequired,
  action: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  variant: PropTypes.oneOf(['secondary', 'outline', 'ghost']),
};

export default SecondaryButton;
